import { FullScreenLoader } from "../full-screen-loader"

export function RoutePending() {
  return <FullScreenLoader />
}
